import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import ProgressiveImage from "react-progressive-image";
import "slick-carousel/slick/slick-theme.css";
class TagSlider extends Component {
    state = {
        tags : [],
    };

    componentDidMount(){
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        axios
        .get('https://pykin.in/public/api/get-tags?latitude='+userSetAddress.lat+'&longitude='+userSetAddress.lng)
        .then((response) => {
            const tags = response.data.tags;
            

            if (tags.length) {
                this.setState({
                    tags: tags
                });
            } else {
                this.setState({
                    tags: [],
                });
            }



        });
    }

    render() {

        const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			adaptiveHeight: false,
			autoplay: true,
			fade: false,
            arrows : false,

			
			infinite: true,
		
			slidesToShow: 1,
			
			
			};
		return (
            <React.Fragment >
          
          {this.state.tags.length > 0 &&(
                <Slider {...settings} >
                {this.state.tags.map(tag => (
                    <DelayLink className="" to={'/offer-section/'+ tag.name.en}>
                        <div className="text-center" key={tag.id}>
                           
                            <ProgressiveImage
						delay={100}
                        src={localStorage.getItem('cdn')+ tag.image}
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					>
						{(src, loading) => (
						 <img style={{borderRadius: '8px'}} height={loading ? '147.391px' : 'auto'} width="100%" src={src}/>
						)}
					</ProgressiveImage>	
                        </div>
                        </DelayLink>
                ))}
                </Slider>
            )}
            </React.Fragment>
        );
    }
}

export default TagSlider;